import React, { Component } from 'react';
import LoadingCube from 'sub_components/Common/LoadingCube';
import { StorageApi } from 'services/storage';
import * as StorageUtils from 'utils/StorageUtils';
import LineGraph from 'sub_components/Common/LineGraph';
import StackedBarGraph from 'sub_components/Common/StackedBarGraph';
import { ToggleButton } from 'styled_components/Common/ToggleButton';
import { DailySelector } from 'styled_components/SVG/DailySelector';
import { MonthlySelector } from 'styled_components/SVG/MonthlySelector';
import { HourlySelector } from 'styled_components/SVG/HourlySelector';

const theme1 = {
	account: '#416ba9',
	support: '#8060a9',
	storage: '#008388',
	billing: '#a8ad00',
	Cool_Gray_Med_1: '#a2a9ad',
	Cool_Gray_Light_3: '#edefef',
};
class ShareTrends extends Component {
	constructor(props) {
		super(props);

		this.state = {
			position: 'left',
			selected: null,
			shares: [],
			share: null,
			shareTrendsData: null,
			selectedDataPoint: null,
			locations: null,
			copyLocations: null,
			LineGraphTitle: 'Total Usage',
			secondCopy: [],
			thirdCopy: [],
			resolution: 'hour',
			unit: 'mb',
			page: 1,
			lineGraphCategories: null,
			currentSelectedDataPoints: null,
			currMin: null,
			currMax: null,
			index: 0,
			loading: true,
			series: null,
			categories: null,
			commitmentAmount: null,
			selectedShareId: null,
		};
	}
	componentDidMount() {
		const { shares, share } = this.props;
		if (shares && shares.length !== 0) {
			const sortedShares = StorageUtils.sortShares(shares);

			this.setState({ shares: sortedShares }, () => {
				this.checkForSelectedShare();
			});
		} else {
			this.getShares();
		}
		this.setShareId(share);
	}

	setShareId = share => {
		this.setState({ selectedShareId: share?.storage_id });
	};

	componentDidUpdate(prevProps) {
		const { selected } = this.state;
		const { share } = this.props;
		const { pathname } = window.location;
		const matches = pathname.split('/');

		if (matches) {
			const [, , , , shareNumber] = matches;
			if (shareNumber && shareNumber !== selected) {
				this.setState({ selected: shareNumber }, () => {
					this.setShare();
				});
			}
		}
		if (prevProps?.share?.storage_id !== share?.storage_id) {
			this.setShareId(share);
		}
	}

	setShare = () => {
		const { shares, selected, share: currentShare } = this.state;
		const { setShareName } = this.props;
		const share = shares.filter(share => share.storage_id === parseInt(selected));
		if (setShareName && share[0] && share[0].name) {
			setShareName(share[0].name);
		}

		if (shares && share[0] && currentShare !== share[0]) {
			this.setState(
				{
					share: share[0],
					resolution: 'hour',
					currentSelectedDataPoints: null,
					selectedDataPoint: null,
					LineGraphTitle: 'Total Usage',
					index: 0,
					shareTrendsData: null,
					copyLocations: [],
					secondCopy: [],
					thirdCopy: [],
					loading: true,
				},
				() => {
					this.getInitialTrendData(share[0]);
				},
			);
		}
	};

	checkSliderPosition = newSelected => {
		const { selected } = this.state;

		let position = 'left';
		if (newSelected === 'month') {
			position = 'right';
		} else if (selected === 'day' && newSelected === 'hour') {
			position = 'left';
		}

		return position;
	};

	getInitialTrendData = async share => {
		const { resolution } = this.state;
		const { id } = this.props;

		await StorageApi.getInitialStorageGraphData(share?.storage_id, resolution, id)
			.then(response => {
				const validResponse = !response.error && response.series;
				if (validResponse) {
					const { unit, series, categories, commitment_amount } = response;
					this.setState(
						{
							series,
							categories,
							unit,
							loading: false,
							commitmentAmount: commitment_amount,
						},
						() => {
							this.onDataPointClick();
						},
					);
				} else {
					this.setState({ error: 'Error pulling storage graph data', loading: false });
				}
			})
			.catch(error => console.log(error));
	};

	getTrendData = async (shareId, page) => {
		const { resolution, unit, categories: currentCategories, series: currentSeries } = this.state;
		const { id } = this.props;

		await StorageApi.getStorageGraphData(shareId, resolution, unit, page, id)
			.then(response => {
				const validResponse = !response.error && response.series;
				if (validResponse) {
					const { unit, series, categories, commitment_amount } = response;

					if (currentCategories) {
						currentCategories.push(...categories);
					}
					if (currentSeries) {
						currentSeries.forEach(current => {
							series.map(data => {
								if (current.name === data.name) {
									const newData = data.data;
									current.data.push(...newData);
								}
							});
						});
					}
					this.setState(
						{
							series: currentSeries,
							categories: currentCategories,
							unit,
							loading: false,
							commitmentAmount: commitment_amount,
						},
						() => {
							this.onDataPointClick();
						},
					);
				} else {
					this.setState({ error: 'Error pulling storage graph data' });
				}
			})
			.catch(error => console.log(error));
	};
	checkForSelectedShare = async () => {
		const id = this.getShareId();

		if (id) {
			this.setState({ selected: id }, () => {
				this.setShare();
			});
		} else {
			const storageShareId = await this.getDefaultStorageShareId();
			if (storageShareId) {
				this.setState({ selected: storageShareId }, () => {
					this.setShare();
				});
			}
		}
	};
	getDefaultStorageShareId = async () => {
		const { shares } = this.props;
		if (shares && shares.length !== 0) {
			const sortedShares = StorageUtils.sortShares(shares);
			return sortedShares[0].storage_id;
		} else {
			const { storages: shares } = await StorageApi.getAll();
			if (shares && shares.length) {
				const sortedShares = StorageUtils.sortShares(shares);
				return sortedShares[0].storage_id;
			}
		}
	};
	getShareId = () => {
		const { pathname } = window.location;
		const matches = pathname.split('/');

		if (matches) {
			const [, , , , shareNumber] = matches;

			if (shareNumber) {
				return shareNumber;
			}
		}
	};

	getShares = async () => {
		await StorageApi.getAll()
			.then(response => {
				const validResponse = !response.error && response.storages;
				if (validResponse) {
					const shares = StorageUtils.sortShares(response.storages);

					this.setState({ shares }, () => {
						this.checkForSelectedShare();
					});
				} else {
					this.setState({ error: 'Error pulling storage details', loading: false });
				}
			})
			.catch(error => console.log(error));
	};

	sortLocations = (locations, size) => {
		const firstCopy = [];
		const secondCopy = [];
		const thirdCopy = [];

		if (!locations) {
			return { firstCopy, secondCopy, thirdCopy };
		}
		const shareSize = size;

		locations.map(location => {
			firstCopy.push(shareSize);
			location.copy_count >= 2 ? secondCopy.push(shareSize) : secondCopy.push(0);
			location.copy_count >= 3 ? thirdCopy.push(shareSize) : thirdCopy.push(0);
		});

		return { firstCopy, secondCopy, thirdCopy };
	};
	onDataPointClick = e => {
		const { series } = this.state;
		const { locations } = this.props;
		const filteredArray = series && series.filter(array => array?.data && array?.data.length !== 0);
		let seriesDefaultPoint = 0;

		filteredArray.filter(dc => {
			const points = dc.data;
			if (points[0] !== 0) {
				seriesDefaultPoint = points[0];
			}

			locations &&
				locations.map(location => {
					if (dc.name === location.tag) {
						seriesDefaultPoint = seriesDefaultPoint / location?.copy_count;
					}
				});
		});

		let selected = e ? e.point.options?.y : seriesDefaultPoint;
		const selectedDC = e ? e.point.series?.name : null;

		if (e) {
			locations.filter(dc => {
				if (selectedDC === dc.tag) {
					selected = selected / dc?.copy_count;
				}
			});
		}

		const { firstCopy, secondCopy, thirdCopy } = this.sortLocations(locations, selected);

		this.setState({
			locations,
			copyLocations: firstCopy,
			secondCopy,
			thirdCopy,
		});
	};

	setResolution = resolution => {
		const { share, unit } = this.state;
		const resolutionLower = resolution && resolution.toLowerCase();

		const position = this.checkSliderPosition(resolution);

		this.setState(
			{
				resolution: resolutionLower,
				currentSelectedDataPoints: null,
				selectedDataPoint: null,
				LineGraphTitle: `Total Usage ${unit}`,
				index: 0,
				shareTrendsData: null,
				copyLocations: [],
				secondCopy: [],
				thirdCopy: [],
				page: 1,
				loading: true,
				position,
			},
			() => {
				this.getInitialTrendData(share);
				this.setShareId(share);
			},
		);
	};
	loadMoreData = page => {
		const { share } = this.props;
		this.getTrendData(share?.storage_id, page);
	};
	getLength = series => {
		const filteredArray = series && series.filter(array => array?.data && array?.data.length !== 0);

		let dataLength = filteredArray?.length;

		if (dataLength === 1) {
			dataLength = 'one';
		} else if (dataLength === 2) {
			dataLength = 'two';
		} else if (dataLength === 3) {
			dataLength = 'three';
		} else if (dataLength === 4) {
			dataLength = 'four';
		}

		return dataLength;
	};

	render() {
		const {
			locations,
			copyLocations,
			secondCopy,
			thirdCopy,
			categories,
			commitmentAmount,
			currentSelectedDataPoints,
			loading,
			position,
			series,
			unit,
			selectedShareId,
		} = this.state;
		const { breakpoint, share } = this.props;

		const graphData = !(series && series?.length === 0);

		const locationNames = [];
		locations && locations.filter(location => locationNames.push(location?.name));

		return (
			<>
				<div
					className={
						!graphData
							? 'share-trend-graph-container no-data-graph'
							: `share-trend-graph-container ${this.getLength(series)}`
					}
				>
					{loading && (
						<div className='loading-cube'>
							<LoadingCube />
						</div>
					)}
					{!graphData && !loading && (
						<div className='no-data-graph-text heading60'>No Data Available</div>
					)}
					{selectedShareId && selectedShareId === share?.storage_id && (
						<div className='storage-graph-resolution-picker'>
							<div className='graph-resolution-picker'>
								<ToggleButton
									module='storage'
									id='toggle-slider-5'
									theme={theme1}
									groupName='togglers-5'
								>
									<HourlySelector
										id='hourly-selector-1'
										module='storage'
										theme={theme1}
										className={'hourly'}
										value='hour'
										onClick={this.setResolution}
									/>
									<DailySelector
										id='daily-selector-1'
										module='storage'
										theme={theme1}
										position={position}
										className={'daily'}
										value='day'
										onClick={this.setResolution}
									/>
									<MonthlySelector
										id='monthly-selector-1'
										module='storage'
										theme={theme1}
										value='month'
										position='left'
										className={'monthly'}
										onClick={this.setResolution}
									/>
								</ToggleButton>
							</div>
						</div>
					)}
					{graphData && !loading && (
						<>
							<LineGraph
								id='storage'
								size='small'
								data={currentSelectedDataPoints}
								series={series}
								categories={categories}
								title={``}
								onClick={this.onDataPointClick}
								breakpoint={breakpoint}
								loadMoreData={this.loadMoreData}
								commitment_amount={commitmentAmount}
								unit={unit}
							/>
							<StackedBarGraph
								id='storage'
								stackOne={copyLocations}
								stackTwo={secondCopy}
								stackThree={thirdCopy}
								categories={locationNames}
								title={''}
								breakpoint={breakpoint}
								yAxisLabel={'{value}'}
							/>
						</>
					)}
				</div>
			</>
		);
	}
}

export default ShareTrends;
